/** @jsx jsx */

import { ProgressBar, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    padding-bottom: 15px;
  `,
  title: css`
    display: flex;
    justify-content: space-between;
  `,
};

type Props = {
  progress: number;
};

const Progress = ({ progress }: Props) => (
  <div css={Styles.root}>
    <title css={Styles.title}>
      <Text color="GrayWarm7" type="Title">
        Updated
      </Text>
      <Text color="GrayWarm7" type="Title">
        {progress}%
      </Text>
    </title>
    <ProgressBar
      color="StatusSuccessWeaker"
      max={100}
      min={1}
      value={progress}
    />
  </div>
);

export default Progress;
